import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ActiveAlarmsPopupComponent } from '../active-alarms-popup/active-alarms-popup.component';
import { AlarmDTO } from '../../models/AlarmDTO';
import { AlarmService } from '../../services/Alarm.service';

import { environment } from "src/environments/environment";

@Component({
  selector: 'active-alarms-list',
  templateUrl: './active-alarms-list.component.html',
  styleUrls: ['./active-alarms-list.component.css']
})
export class ActiveAlarmsListComponent {

  isLoading: boolean = false;
  isVisible: boolean = false;
  isalarmEnd: boolean = false;
  alarmList: AlarmDTO[] = [];

  subscription_GetAlarms: Subscription;

  constructor(
    public alarmService: AlarmService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ActiveAlarmsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){

  }

  ngOnInit(): void {
    this.getAlarms(1);
  }

  ngOnDestroy() {
    if(this.subscription_GetAlarms)
      this.subscription_GetAlarms.unsubscribe();
  }

  getAlarms(page : number) {
    if(this.isalarmEnd){
      return;
    }

    this.isLoading = true;
    this.subscription_GetAlarms = this.alarmService.getImportantAlarmsPage(page).subscribe({
      next: (data) => {
        if (data.isSuccess) {
          if(!environment.production) console.log('alarm data', data);
          
          // si ya no hay datos, se termina la busqueda
          if (data.result.length == 0) {
            this.isalarmEnd = true;
            if (this.subscription_GetAlarms)
              this.subscription_GetAlarms.unsubscribe();
            var empty = new Array<AlarmDTO>();
            this.setAlarmPage(empty, page);
            return;
          }

          // si hay menos de 10 elementos, se asignan los que hay y termina la busqueda
          if (data.result.length < 10) {
            this.isalarmEnd = true;
            if (this.subscription_GetAlarms)
              this.subscription_GetAlarms.unsubscribe();
            this.setAlarmPage(data.result, page);
            return;
          }

          this.setAlarmPage(data.result, page);
        }
        this.isLoading = false;
      },
      error: (error) => {
        // TODO marca para complete despues
        this.isLoading = false;
        console.error('Error al obtener alarmas', error);
      }
    });
  }

  setAlarmPage(result: any, page: number) {
    if(page == 1)
      this.setAlarmList(result);

    if(page != 1)
      this.addAlarmListToList(result);
  }

  setAlarmList(alarmList: AlarmDTO[]) {
    this.alarmList = alarmList;
    this.isLoading = false;
  }

  addAlarmToList(alarm: AlarmDTO) {
    this.alarmList.push(alarm);
  }

  addAlarmListToList(alarmList: AlarmDTO[]) {
    // se añaden los elementos de la lista de notificaciones obtenidas a la lista de notificaciones actual con set para evitar duplicados
    this.alarmList = Array.from(new Set(this.alarmList.concat(alarmList)));
    this.isLoading = false;
  }



  onScroll(event: any): void {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.loadMoreAlarms();
    }
  }

  loadMoreAlarms(): void {
    // se obtiene la página de tal forma que si hay números residuales, se vuelva a pedir desde la página con los residuos incluidos, para evitar lapsos
    var page = 0;
    var length = this.alarmList.length;
    var residue = length % 10;
    if (residue != 0) {
      page = Math.floor(length / 10);
      // si el numero de residuo es mayor a 0 pero el total menor a 10, dará 0, se suma 1 a la página para que se pida desde la primera
      if(page < 1){
        page = 1;
      }
    }else{
      page = (length / 10) + 1;
    }
    if(!environment.production) console.log('page', length, residue, page);
    this.getAlarms(page);
  }

  onalarmClick(event: any) {
    if(!environment.production) console.log('alarm event', event);
    const dialogRef = this.dialog.open(ActiveAlarmsPopupComponent, {
      width: "auto",
      height: "fit-content",
      autoFocus: false,
      restoreFocus: false,
      data: event
    });

    dialogRef.afterClosed().subscribe(reload => {
      if(reload){
        this.alarmList = new Array<AlarmDTO>();
        this.isalarmEnd = false;
        this.getAlarms(1);
      }
      if(!environment.production) console.log('cerrado');
    });
  }

  close(){
    this.alarmService.isAlarmListVisible = false;
    this.dialogRef.close();
  }

}
